<div class="language-selector-modal">
    <div tabindex="0"></div>
    <h2>RAPIDSCORE</h2>
    <div class="button-container">
        <button *ngFor="let language of languages" (click)="selectLanguage(language.code)">
            {{ language.name | translate }}
        </button>
    </div>
</div>